import Vue from 'vue'
import Vuex from 'vuex'
import booking from './modules/booking/booking'

Vue.use(Vuex)
Vue.config.devtools = !!(window.initData.debugMode & (1 << 3))

export default new Vuex.Store({
  modules: {
    booking
  },
  strict: process.env.NODE_ENV !== 'production'
})
